module.exports = __webpack_public_path__ + "static/media/logo-dark.862382b6.png";